import { useEffect, useMemo } from 'react';

import { useLazyService } from '@atlassian/teams-common/use-service';

import type { JiraCheckData, JiraCheckServiceFn, JiraCheckServiceReturnType } from './types';
import { defaultRequestAbort } from './utils';

export const useLazyJiraCheckService: JiraCheckServiceFn = (cloudId, options) => {
	const [request, controller] = useMemo(() => defaultRequestAbort(cloudId), [cloudId]);

	const [getJiraCheck, result] = useLazyService<JiraCheckData>(request, controller, {
		initialState: { ...options?.initialState },
	});

	return [
		getJiraCheck,
		{
			...result,
			isJiraAvailable: Boolean(result.data?.permitted),
		},
	];
};

export const useJiraCheckService = (
	...[cloudId, options]: Parameters<JiraCheckServiceFn>
): JiraCheckServiceReturnType => {
	const [getJiraCheck, result] = useLazyJiraCheckService(cloudId, options);

	useEffect(() => {
		if (cloudId) {
			getJiraCheck();
		}
	}, [cloudId, getJiraCheck]);

	return result;
};
